// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__uM6x1","footer":"ModalFilter_footer__1zPc6"};